export const BUILD_VERSION = '1790185377';
